<template>
  <div id="HelloWorld">
    <b-alert
      :show="dismissCountDown"
      variant="success"
      @dismissed="onDismissed"
      @dismiss-count-down="countDownChanged"
    >
      <p>簽到成功 {{ dismissCountDown }} 秒後前往課程頁面...</p>
      <b-progress
        variant="success"
        :max="dismissSecs"
        :value="dismissCountDown"
        height="4px"
      ></b-progress>
    </b-alert>
    <b-alert v-if="isDisabled"
     show variant="danger"
    >
      <p>簽到時間為 {{ startTime }} ~ {{ endTime }}</p>
    </b-alert>
    <h3 v-if="shareLinkName">【{{shareLinkName}}】簽到，請填《護持班級名稱》</h3>
    <h3 v-else>請填《護持班級名稱》</h3>
    <b-form :validated="isValidated" v-if="!isSuccess&&!isDisabled">
      <b-form-group label="區別:" label-for="area" class="mb-3">
        <b-form-select v-model="form.lmClassArea" :options="areaOptions" required></b-form-select>
      </b-form-group>
      <b-form-group v-if="form.lmClassArea != '海外'" label="年度:" label-for="lmClassYear" class="mb-3">
        <b-form-select v-model="form.lmClassYear" :options="yearOptions" required></b-form-select>
      </b-form-group>
      <b-form-group v-if="form.lmClassArea != '海外'" label="班階:" label-for="lmClassLevel" class="mb-3">
        <b-form-select v-model="form.lmClassLevel" :options="levelOptions" required></b-form-select>
      </b-form-group>
      <b-form-group v-if="form.lmClassArea != '海外'" label="班號:(3位數字)" label-for="lmClassNo" class="mb-3">
        <b-form-input id="lmClassNo" v-model="form.lmClassNo" placeholder="請輸入班號" required></b-form-input>
      </b-form-group>
      <b-form-group v-else label="班名:" label-for="lmClassName" class="mb-3">
        <b-form-input id="lmClassName" v-model="form.lmClassName" placeholder="請輸入班名" required></b-form-input>
      </b-form-group>
        <b-form-group label="班級名稱:" class="mb-3">
          <h3>{{computedLmClassName}}</h3>
      </b-form-group>
      <b-form-group label="姓名:" label-for="name" class="mb-3">
        <b-form-input id="name" v-model="form.name" placeholder="請輸入姓名" required></b-form-input>
      </b-form-group>
      <b-button variant="primary" @click="onSignUp">簽到</b-button>
    </b-form>

  </div>
</template>

<script>
const baseUrl = "";
//const baseUrl = "http://127.0.0.1:8080";
export default {
  name: "HelloWorld",
  components: {},
  data() {
    return {
      startTime: null,
      endTime: null,
      isDisabled: false,
      isShowInfo: false,
      isSuccess: false,
      dismissSecs: 5,
      dismissCountDown: 0,
      showDismissibleAlert: false,
      shareLinkName: null,
      url: null,
      isValidated: null,
      areaOptions:[
        {
          value:"北",
          text:"北區"
        },
        {
          value:"桃",
          text:"桃區"
        },
        {
          value:"竹",
          text:"竹區"
        },
        {
          value:"中",
          text:"中區"
        },
        {
          value:"嘉",
          text:"嘉區"
        },
        {
          value:"南",
          text:"南區"
        },
        {
          value:"園",
          text:"園區"
        },
        {
          value:"高",
          text:"高區"
        },
        {
          value:"海外",
          text:"海外:世界各國"
        },
      ],
      yearOptions:[],
      levelOptions:[
        {value: "春",text:"春"},
        {value: "秋",text:"秋"},
        {value: "增",text:"增"},
        {value: "善",text:"善"},
        {value: "備",text:"備"},
        {value: "宗",text:"宗"}
        ],
      form: {
        region: null,
        name: null,
        lmClassArea: null,
        lmClassYear: null,
        lmClassLevel: null,
        lmClassNo: null,
        lmClassName: null,
        shareLinkCode: null
      }
    };
  },
  computed: {
    computedLmClassName: {
      get: function() {
        if(this.form.lmClassArea == "海外") {
          return `${this.form.lmClassName??''}`;
        }else {
          return `${this.form.lmClassArea??''}${this.form.lmClassYear??''}${this.form.lmClassLevel??''}${this.form.lmClassNo??''}`;
        }
      }
    }
  },
  async created() {
    const maxYear = new Date().getFullYear()-2000;
      for(var i=10;i<=maxYear;i++){
        this.yearOptions.push({value:`${i}`, text:`${i}`});
      }
      fetch(`${baseUrl}/api/sharelink`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ code: `${this.$route.params.shareLinkCode}`})
      }).then(async res=>{
        const json = await res.json();
        const now = new Date();
        this.isDisabled = !(now >= new Date(json.startTime) && now <= new Date(json.endTime));
        this.startTime = new Date(json.startTime).toLocaleString();
        this.endTime = new Date(json.endTime).toLocaleString();
      })
      this.timer();
  },
  methods: {
    async timer() {
        setInterval(async()=>{ 
                fetch(`${baseUrl}/api/sharelink`, {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({ code: `${this.$route.params.shareLinkCode}`})
      }).then(async res=>{
        const json = await res.json();
        const now = new Date();
        this.isDisabled = !(now >= new Date(json.startTime) && now <= new Date(json.endTime));
        this.startTime = new Date(json.startTime).toLocaleString();
        this.endTime = new Date(json.endTime).toLocaleString();
        this.shareLinkName = json.name;
      })
         }, 60000);
    },
    onDismissed(){
      this.dismissCountDown=0
      if(this.url){
        window.location.href = this.url;
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    async onSignUp() {
      if(!this.form.name || !this.form.lmClassArea){
        this.isValidated = true;
      }
      if(this.form.lmClassArea == '海外') {
        if(!this.form.lmClassName) {
          this.isValidated = true;
        }
      } else {
        if(!this.form.lmClassYear || !this.form.lmClassLevel || !this.form.lmClassNo) {
          this.isValidated = true;
        }
      }
      if(this.isValidated){
        return;
      }
      const res = await fetch(`${baseUrl}/api/record`, {
        mode: 'cors',
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          region: this.form.lmClassArea,
          classname: this.computedLmClassName,
          name: this.form.name,
          shareLinkCode: this.$route.params.shareLinkCode
        }),
      });
      const url = await res.text()
      if (url) {
        this.isSuccess = true;
        this.showAlert();
        this.url = url;
      }
    },
    async onSignIn() {
      if(!this.form.name || !this.phoneValid){
        this.isValidated = true;
        return;
      }
      const res = await fetch(`${baseUrl}/api/signin`, {
        mode: 'cors',
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify(this.form),
      });
      const json = await res.json();
      if (json.code == 200) {
        this.isSuccess = true;
        this.showAlert();
        this.url = json.url;
        //window.location.href = json.url;
      } else if (json.code == 404) {
        this.isSignUpMode = true;
      }
    },
    onSubmit(event) {
      event.preventDefault();
      alert(JSON.stringify(this.form));
    },
    onReset(event) {
      event.preventDefault();
      // Reset our form values
      this.form.email = "";
      this.form.name = "";
      this.form.food = null;
      this.form.checked = [];
      // Trick to reset/clear native browser form validation state
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
